export const AUDIENCES_GETTING_STARTED_URL =
  'http://help.proxima.ai/en/articles/6038493-getting-started';

export const AUDIENCES_METHODOLOGIES_GUIDE_URL =
  'http://help.proxima.ai/en/articles/6974091-campaign-setup-testing-methodologies';

export const META_BENCHMARKS_HELP_GUIDE_URL =
  'http://help.proxima.ai/en/collections/8378330-meta-benchmarks';
